"use strict";
/**
 * Created by Ning Jiang on 4/1/2016.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BalanceEvent = void 0;
class BalanceEvent {
}
BalanceEvent.BALANCE = "balanceEvent_balance";
BalanceEvent.CURRENCY = "balanceEvent_currency";
BalanceEvent.CURRENT_BET = "balanceEvent_currentBet";
BalanceEvent.BET_LEVELS = "balanceEvent_betLevels";
BalanceEvent.FREE_BETS = "balanceEvent_freeBets";
// a bet that made by user clicking the keypad.
BalanceEvent.BET = "balanceEvent_bet";
// a bet that starts by respin/freespin from the game flow.
BalanceEvent.ZERO_BET = "balanceEvent_zeroBet";
BalanceEvent.PICK_AND_CLICK = "balanceEvent_pickAndClick";
exports.BalanceEvent = BalanceEvent;
//# sourceMappingURL=BalanceEvent.js.map